import { useEffect } from 'react';
import CONSTANTS from '../Constants';
import useCustomNavigation from './use-custom-navigation';
import useStores from './use-stores';

const useAuthRedirect = () => {
    const { authStore } = useStores();
    const customNavigate = useCustomNavigation();

    useEffect(() => {
        if (!localStorage.getItem(CONSTANTS.LOCAL_STORAGE_KEYS.ACCESS_TOKEN)) {
            customNavigate(CONSTANTS.SCREEN.LOGIN);
            localStorage.clear();
            authStore.clearAuthInfo();
        }
        //eslint-disable-next-line
    }, [window.location.pathname]);
};

export default useAuthRedirect;
